import { HttpResourceRequest } from '@angular/common/http';
import { CaseSortOrder } from '@shared/enums/case-library';
import { CaseSearch } from '@shared/models';

/** Each order as the sort menu names it, and as the title of the cases it lists. */
export const CASE_SORTS: Record<CaseSortOrder, { label: string; title: string }> = {
  [CaseSortOrder.NewestFirst]: { label: 'Newest first', title: 'Recent cases' },
  [CaseSortOrder.OldestFirst]: { label: 'Oldest first', title: 'Oldest cases' },
  [CaseSortOrder.LongestFirst]: { label: 'Longest first', title: 'Longest cases' },
  [CaseSortOrder.ShortestFirst]: { label: 'Shortest first', title: 'Shortest cases' },
  [CaseSortOrder.TitleAsc]: { label: 'Title (A-Z)', title: 'Cases (A-Z)' },
};

/** The sort orders in the order the sort menus list them. */
export const CASE_SORT_ORDERS: readonly CaseSortOrder[] = Object.values(CaseSortOrder);

/**
 * The filtering is the endpoint's: a library is paged, so narrowing what is loaded hides cases.
 * Only what was chosen is sent, and sorted, so the same choice cannot read the library twice.
 */
export function caseSearchRequest(apiUrl: string, search: CaseSearch): HttpResourceRequest {
  const body: Record<string, unknown> = {};
  if (search.categories?.length) {
    body['categories'] = [...search.categories].sort((a, b) => a.localeCompare(b));
  }
  if (search.favouritesOnly) {
    body['favouritesOnly'] = true;
  }
  if (search.startDate) {
    body['startDate'] = search.startDate;
  }
  if (search.endDate) {
    body['endDate'] = search.endDate;
  }
  if (search.publicationStatus) {
    body['publicationStatus'] = search.publicationStatus;
  }
  if (search.searchText) {
    body['searchText'] = search.searchText;
  }
  if (search.sortOrder && search.sortOrder !== CaseSortOrder.NewestFirst) {
    body['sortOrder'] = search.sortOrder;
  }
  return { url: `${apiUrl}/v1/videos/search`, method: 'POST', body };
}
